class WLSBuybox extends HTMLElement {
    constructor() {
        super();

        this.options = this.querySelectorAll('.js-options-wrapper');
        this.addToCart = this.querySelector('.js-add-to-cart');
        this.optionsCount = Array.from(this.options).map(wrapper => wrapper.dataset.defaultOptionId);
        this.quantityPicker = this.querySelector('.js-quantity');
        this.quantityMinus = this.querySelector('.js-wls-buybox-qty-minus');
        this.quantityPlus = this.querySelector('.js-wls-buybox-qty-plus');
        this.upsellWrapper = this.querySelector('.js-upsell-wrapper');
        this.subscriptionPicker = this.querySelectorAll('input[name="selling-plan"]');
        this.sellingPlans = this.querySelectorAll('.js-selling-plans-wrapper');
        this.price = this.querySelector('.js-price');
        this.comparePrice = this.querySelector('.js-compare-at-price');
        this.sellingPlanSelect = this.querySelector('select[name="selling-plan-id"]');
        this.galleryThumbnails = this.querySelector('.js-wls-buybox-gallery-thumbs');
        this.galleryMain = this.querySelector('.js-wls-buybox-gallery-main');
        this.zoomTrigger = this.querySelector('.js-wls-buybox-zoom-trigger');
        this.zoomModal = this.querySelector('.js-wls-buybox-zoom-modal');
        this.zoomGallery = this.querySelector('.js-wls-buybox-zoom-gallery');
        this.zoomModalClose = this.querySelector('.js-wls-buybox-zoom-modal-close');
        this.zoomModalOpen = 'modal-open'
        this.gallerySlider = null;
        this.galleryThumbnailsSlider = null;
        this.zoomSlider = null;
    }

    connectedCallback() {
        this.bindEvents();
        this.fetchRecommendations();
        this.initGallery();
        this.initZoomModal();
    }


    bindEvents() {
        if (this.options) {
            this.optionEvents();
        }

        if (this.addToCart) {
            this.addToCart.addEventListener('click', (e) => {
                e.preventDefault();
                this.onAddToCartClick();
            });
        }

        if (this.quantityPicker) {
            if (this.quantityPlus) {
                this.quantityPlus.addEventListener("click", () => {
                    let currentValue = parseInt(this.quantityPicker.value) || 0;
                    this.quantityPicker.value = currentValue + 1;
                    this.addToCart.dataset.quantity = this.quantityPicker.value;

                });
            }
            if (this.quantityMinus) {
                this.quantityMinus.addEventListener("click", () => {
                    let currentValue = parseInt(this.quantityPicker.value) || 0;
                    if (currentValue > 1) {
                        this.quantityPicker.value = currentValue - 1;
                        this.addToCart.dataset.quantity = this.quantityPicker.value;

                    }
                });
            }
            this.quantityPicker.addEventListener('change', this.onQuantityChange.bind(this));
        }

        if (this.subscriptionPicker) {
            this.subscriptionPicker.forEach((picker) => {
                picker.addEventListener('change', (event) => {
                    this.onSubscriptionChange(event);
                });
            });
        }

        if (this.sellingPlanSelect) {
            this.sellingPlanSelect.addEventListener('change', (event) => {
                this.onSellingPlanChange();
            });
        }
    }

    optionEvents() {
        this.options.forEach((optionWrapper, index) => {
            const options = optionWrapper.querySelectorAll('.js-option');
            options.forEach((option) => {
                option.addEventListener('click', (event) => {
                    event.preventDefault();

                    const imgEl = option;

                    let fileName = null;

                    if (imgEl && imgEl.dataset.imgSrc) {
                        const optionURL = imgEl.dataset.imgSrc.replace(/(&|\?)width=\d+/, '');
                        const cleanSrc = optionURL.split('?')[0];
                        fileName = cleanSrc.split('/').pop();
                    }

                    const imageSelector = fileName
                        ? this.galleryThumbnails.querySelector(`img[src*="${fileName}"]`)
                        : null;

                    options.forEach((opt) => opt.classList.remove('selected'));
                    option.classList.add('selected');

                    this.optionsCount[index] = option.getAttribute('data-id');
                    this.onOptionChange();
                    if (imageSelector) {
                        imageSelector.click();
                    }
                });
            });
        });
    }


    fetchRecommendations() {
        const productId = this.dataset.productId;
        const container = document.querySelector('.js-upsell-wrapper');
        fetch(`/recommendations/products?section_id=wls-recommendations&product_id=${productId}`)
            .then(res => res.text())
            .then(html => {
                if (container) {
                    container.innerHTML = html;
                }
            });
    }


    onSellingPlanChange() {
        const selectedPlan = this.sellingPlanSelect.value;

        this.addToCart.dataset.sellingPlanId = selectedPlan;
    }

    onQuantityChange() {
        const quantity = this.quantityPicker.value;

        this.addToCart.dataset.quantity = quantity;
    }

    onSubscriptionChange(event, onetime = false) {
        const target = event.target;
        const parent = target.closest('.js-selling-plans-wrapper');

        // Handle Active Classes
        this.sellingPlans.forEach((picker) => {
            picker.classList.remove('active');
        });
        parent.classList.add('active');

        // Change Prices
        const price = parent.dataset.price;
        const comparePrice = parent.dataset.compareAtPrice;

        this.price.innerHTML = price;
        this.comparePrice.innerHTML = `<del class="wls-title-h5 md:wls-title-h4">${comparePrice}</del>`;

        this.addToCart.dataset.sellingPlanId = parent.classList.contains('onetime') ? '' : this.sellingPlanSelect.value;
    }

    onOptionChange() {
        const options = this.optionsCount.map(option => option).join(',');

        const params = new URLSearchParams(window.location.search);
        params.set('option_values', options);

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);

        this.updateBuybox();
    }


    updateBuybox() {
        fetch(window.location + '?view=wollson')
            .then(response => response.text())
            .then(htmlString => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(htmlString, 'text/html');

                const newPriceSection = doc.querySelector('.js-prices');
                const priceSection = document.querySelector('.js-prices');

                const newOptions = doc.querySelectorAll('.js-options-wrapper');

                const newOptionsTitles = doc.querySelectorAll('.js-options-title');
                const optionsTitles = document.querySelectorAll('.js-options-title');

                const newAtcBtn = doc.querySelector('.js-add-to-cart');
                if (newAtcBtn) {
                    this.addToCart.dataset.id = newAtcBtn.dataset.id;
                }

                if (newPriceSection && priceSection) {
                    priceSection.innerHTML = newPriceSection.innerHTML;
                }

                if (newOptions) {
                    this.options.forEach((option, index) => {
                        option.innerHTML = newOptions[index].innerHTML;
                    });
                    this.optionEvents();
                }

                if (newOptionsTitles) {
                    optionsTitles.forEach((title, index) => {
                        title.innerHTML = newOptionsTitles[index].innerHTML;
                    });
                }
            })
            .catch(error => {
                console.error('Error fetching HTML:', error);
            });
    }


    onAddToCartClick() {
        const id = this.addToCart.dataset.id;
        const quantity = this.addToCart.dataset.quantity;
        const sellingPlanId = this.addToCart.dataset.sellingPlanId;

        this.handleAddToCartState('start');

        fetch(window.location.origin + '/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: id,
                    quantity: quantity,
                    selling_plan: sellingPlanId
                }]
            })
        }).then(response => {
            if (response.ok) {
                this.handleAddToCartState('success');
                this.refreshCart();
            }
        });
    }

    handleAddToCartState(state) {
        const originalText = this.addToCart.dataset.originalText || this.addToCart.innerText;

        if (!this.addToCart.dataset.originalText) {
            this.addToCart.dataset.originalText = originalText;
        }

        if (state === 'start') {
            this.addToCart.innerHTML =
                `
            <svg class="wls-buybox__button-loader" width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2391_2305)">
        <rect x="5.83984" y="18.5684" width="2.25" height="2.25" rx="1.125" transform="rotate(-45 5.83984 18.5684)" fill="white"/>
        </g>
        <g clip-path="url(#clip1_2391_2305)">
        <rect x="11.873" y="22.0015" width="2.25" height="2.25" rx="1.125" transform="rotate(-90 11.873 22.0015)" fill="white"/>
        </g>
        <g clip-path="url(#clip2_2391_2305)">
        <rect x="18.5703" y="20.1594" width="2.25" height="2.25" rx="1.125" transform="rotate(-135 18.5703 20.1594)" fill="white"/>
        </g>
        <g clip-path="url(#clip3_2391_2305)">
        <rect x="22.002" y="14.1265" width="2.25" height="2.25" rx="1.125" transform="rotate(-180 22.002 14.1265)" fill="white"/>
        </g>
        <g clip-path="url(#clip4_2391_2305)">
        <rect x="20.1602" y="7.43164" width="2.25" height="2.25" rx="1.125" transform="rotate(135 20.1602 7.43164)" fill="white"/>
        </g>
        <g clip-path="url(#clip5_2391_2305)">
        <rect x="14.123" y="4.00146" width="2.25" height="2.25" rx="1.125" transform="rotate(90 14.123 4.00146)" fill="#F1D077"/>
        </g>
        <g clip-path="url(#clip6_2391_2305)">
        <rect x="7.43359" y="5.84033" width="2.25" height="2.25" rx="1.125" transform="rotate(45 7.43359 5.84033)" fill="white"/>
        </g>
        <g clip-path="url(#clip7_2391_2305)">
        <rect x="4.00195" y="11.8765" width="2.25" height="2.25" rx="1.125" fill="white"/>
        </g>
        <defs>
        <clipPath id="clip0_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(0.271484 13) rotate(-45)"/>
        </clipPath>
        <clipPath id="clip1_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(3.99805 22.0015) rotate(-90)"/>
        </clipPath>
        <clipPath id="clip2_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(13.002 25.7278) rotate(-135)"/>
        </clipPath>
        <clipPath id="clip3_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(22.002 22.0015) rotate(-180)"/>
        </clipPath>
        <clipPath id="clip4_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(25.7285 13) rotate(135)"/>
        </clipPath>
        <clipPath id="clip5_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(21.998 4.00146) rotate(90)"/>
        </clipPath>
        <clipPath id="clip6_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(13.002 0.271973) rotate(45)"/>
        </clipPath>
        <clipPath id="clip7_2391_2305">
        <rect width="18" height="18" fill="white" transform="translate(4.00195 4.00146)"/>
        </clipPath>
        </defs>
        </svg>
            <span>Adding</span>`;
            this.addToCart.classList.add('adding-state');
        }

        if (state === 'success') {
            this.addToCart.innerHTML =
                `<svg {{ icon_props }} width="11" height="8" viewBox="0 0 11 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 3.7L3.7 6.39999L9.09999 1" stroke="#F1D077" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Added</span>
            `;

            setTimeout(() => {
                this.addToCart.innerText = this.addToCart.dataset.originalText;
                this.addToCart.classList.remove('adding-state');
            }, 2000);
        }
    }

    refreshCart() {
        fetch('/cart')
            .then(res => res.text())
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                const newCart = doc.querySelector('cart-drawer')
                const currentCart = document.querySelector('cart-drawer');
                if (newCart) {
                    currentCart.replaceWith(newCart);
                    window.Wollson.showCart();
                } else {
                    console.error('No <wls-cart> found in response HTML');
                }
            })
            .catch(err => console.error('Error refreshing cart:', err));
    }

    initGallery() {
        if (this.galleryMain && this.galleryThumbnails) {
          this.gallerySlider = new Splide(this.galleryMain, {
            type: 'slide',
            rewind: true,
            focus: 'left',
            pagination: false,
            arrows: false,
          });
      
          this.galleryThumbnailsSlider = new Splide(this.galleryThumbnails, {
            isNavigation: true,
            gap: 16,
            focus: 'left',
            pagination: false,
            cover: true,
            arrows: false,
            fixedWidth: 80,
            fixedHeight: 72,
            direction: 'ttb',
            height: '520px',
            breakpoints: {
              1025: {
                direction: 'ltr',
                height: '48px',
                fixedWidth: 50,
                fixedHeight: 48,
                gap: 7,
              },
            },
          });
      
          this.gallerySlider.sync(this.galleryThumbnailsSlider);
      
          this.gallerySlider.mount();
          this.galleryThumbnailsSlider.mount();
      
          this.gallerySlider.on('moved', (newIndex) => {
            if (this.zoomGallerySlider && this.zoomGallerySlider.index !== newIndex) {
              this.zoomGallerySlider.go(newIndex);
            }
          });
        }
      }
      
      initZoomModal() {
        if (this.zoomModal && this.zoomTrigger) {
          this.zoomTrigger.addEventListener('click', () => {
            this.zoomModal.classList.add(this.zoomModalOpen);
            document.body.style.overflow = 'hidden';
      
            if (this.zoomGallery && !this.zoomGallerySlider) {
              this.zoomGallerySlider = new Splide(this.zoomGallery, {
                type: 'slide',
                rewind: true,
                perPage: 1,
                perMove: 1,
                focus: 'left',
                pagination: false,
                arrows: true,
                gap: '1rem',
                drag: true,
              });
              this.zoomGallerySlider.mount();
      
              this.zoomGallerySlider.on('moved', (newIndex) => {
                if (this.gallerySlider && this.gallerySlider.index !== newIndex) {
                  this.gallerySlider.go(newIndex);
                }
              });
            }
      
            if (this.gallerySlider && this.zoomGallerySlider) {
              this.zoomGallerySlider.go(this.gallerySlider.index);

              setTimeout(() => this.zoomGallerySlider.refresh(), 0);
            }
          });
      
          if (this.zoomModalClose) {
            this.zoomModalClose.addEventListener('click', () => {
              this.zoomModal.classList.remove(this.zoomModalOpen);
              document.body.style.overflow = 'visible';
            });
          }
        }
      }
}

if (customElements.get('wls-buybox') === undefined) {
    customElements.define('wls-buybox', WLSBuybox);
}